import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HeaderService } from './header.service';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ShipReportService {

  constructor(private http: HttpClient, private headerService: HeaderService, private authService: AuthService) { }

  showReports() {
    const url = `${environment.rootApiUrl}/reports/ship/search/reportSeq`;
    return this.http.get(url, this.headerService.getHttpOptionsXAuthHeaderFromCookie());
  }

  getBatchId(location: string) {
    const url = `${environment.rootApiUrl}/reports/ship/search/batches`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('location', location);

    return this.http.get(url, { headers: this.headerService.getXAuthHeaderFromCookie(), params: httpParams });
  }

  searchTransactions(data: object) {
    let httpParams = new HttpParams();
    const keys = Object.keys(data);
    for (const prop of keys) {
      if (data[prop]) {
        httpParams = httpParams.append(prop.trim(), data[prop].trim());
      } else {
        httpParams = httpParams.append(prop.trim(), '');
      }
    }
    const url = `${environment.rootApiUrl}/reports/ship/search/transactions`;

    return this.http.post(url, {}, { headers: this.headerService.getXAuthHeaderFromCookie(), params: httpParams });
  }

  getSearchPage() {
     const url = `${
      environment.rootApiUrl
      }/reports/ship/search/`;
     return this.http.get(url, this.headerService.getHttpOptionsXAuthHeaderFromCookie());
  }

  getShipById() {
    const url = `${environment.rootApiUrl}/reports/ship/search/location`;
    return this.http.get(url, this.headerService.getHttpOptionsXAuthHeaderFromCookie());
  }

  getHeader() {
    let header = this.headerService.getXAuthHeader(
      this.authService.getUser().token
    );
    header = header.append(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );
    return header;
  }

  storeReport(report: object) {
    window.sessionStorage.setItem(
      'reports',
      JSON.stringify(report)
    );
  }

  getReport() {
    const recentReport = window.sessionStorage.getItem('reports');
    let parsedReport: object = null;
    if (recentReport) {
      parsedReport = JSON.parse(recentReport);
    }
    return parsedReport;
  }

  clearReport() {
    window.sessionStorage.removeItem('reports');
  }

  downloadReport(reportSeq: string) {
    const url = `${environment.rootApiUrl}/reports/ship/search/report/download`;
    const params = new HttpParams().append('reportSeq', reportSeq);

    return this.http.post(url, params, {headers: this.headerService.getXAuthHeaderFromCookie(), responseType: 'arraybuffer'});
  }

  downloadVisaReport(fileName: string) {
    const url = `${environment.rootApiUrl}/reports/ship/search/VISAReport/download`;
    const params = new HttpParams().append('fileName', fileName);

    return this.http.post(url, params, {headers: this.headerService.getXAuthHeaderFromCookie(), responseType: 'arraybuffer'});
  }

  downloadReportByName(reportName: string) {
    const url = `${environment.rootApiUrl}/reports/ship/search/report/download/SNOW`;
    const params = new HttpParams().append('fileNameB', reportName);

    return this.http.post(url, params, {headers: this.headerService.getXAuthHeaderFromCookie(), responseType: 'arraybuffer'});
  }

}
